import { AxiosRequestConfig } from 'axios';
import * as uuid from 'uuid';

export function SepararIdUrl(url: string, config?: AxiosRequestConfig): string {
  let id = url.split('/').filter(item => uuid.validate(item))[0];

  if (id.length === 0) {
    id = config?.headers.propriedade_id;
  }

  return id;
}
